'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _dec3, _class, _class2, _temp;

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Digi = require('./Digi.scss');

var _Digi2 = _interopRequireDefault(_Digi);

var _Link = require('components/Link/Link');

var _Link2 = _interopRequireDefault(_Link);

var _reactIntl = require('react-intl');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRedux = require('react-redux');

var _session = require('redux/modules/session');

var _digi = require('redux/modules/digi');

var _FeaturedReviews = require('components/Home/FeaturedReviews');

var _FeaturedReviews2 = _interopRequireDefault(_FeaturedReviews);

var _AsSeenOn = require('components/Home/AsSeenOn');

var _AsSeenOn2 = _interopRequireDefault(_AsSeenOn);

var _Modal = require('components/General/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _SeeInspiration = require('components/Home/SeeInspiration');

var _SeeInspiration2 = _interopRequireDefault(_SeeInspiration);

var _AboutLocalExperts = require('components/Home/AboutLocalExperts');

var _AboutLocalExperts2 = _interopRequireDefault(_AboutLocalExperts);

var _Breadcrumbs = require('components/Breadcrumbs/Breadcrumbs');

var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);

var _Trip = require('components/Trip/Trip');

var _Trip2 = _interopRequireDefault(_Trip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Digi: {
    displayName: 'Digi'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/containers/Digi/Digi.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import HomeWhatUsersSay from 'components/Home/HomeWhatUsersSay';
// import Slider from 'react-slick';

// import { isLoaded, load as loadHomeInfo } from 'redux/modules/home';

// import InspirationBox from 'components/Dtac/InspirationBox';


var Digi = _wrapComponent('Digi')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    if (!(0, _digi.isLoaded)(getState())) {
      return dispatch((0, _digi.load)());
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    trips: state.digi.trips,
    inspirations: state.digi.inspirations,
    localExperts: state.digi.localExperts,
    reviews: state.digi.reviews,
    home: state.home.data,
    locale: state.language.locale
  };
}, { openSignup: _session.openSignup, setSessionData: _session.setSessionData, loadSessionData: _session.loadSessionData, setOldPromo: _session.setOldPromo }), _dec3 = (0, _reactCssModules2.default)(_Digi2.default), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Digi, _Component);

  function Digi(props) {
    (0, _classCallCheck3.default)(this, Digi);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Digi.__proto__ || (0, _getPrototypeOf2.default)(Digi)).call(this, props));

    _this.state = {
      isOpenTermModal: false
    };

    _this.openSignup = _this.openSignup.bind(_this);

    if (!(typeof _this.openSignup === 'function')) {
      throw new TypeError('Value of "this.openSignup" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.openSignup));
    }

    _this.openTermModal = _this.openTermModal.bind(_this);

    if (!(typeof _this.openTermModal === 'function')) {
      throw new TypeError('Value of "this.openTermModal" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.openTermModal));
    }

    _this.closeTermModal = _this.closeTermModal.bind(_this);

    if (!(typeof _this.closeTermModal === 'function')) {
      throw new TypeError('Value of "this.closeTermModal" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.closeTermModal));
    }

    return _this;
  }

  (0, _createClass3.default)(Digi, [{
    key: 'openSignup',
    value: function openSignup() {
      // this.props.setSessionData({promo: 'DIGI40'})
      // .then(()=> this.props.loadSessionData())
      // .then(()=> this.props.setOldPromo());
      this.props.setOldPromo();
      this.props.openSignup();
    }
  }, {
    key: 'openTermModal',
    value: function openTermModal() {
      this.setState({ isOpenTermModal: true });
    }
  }, {
    key: 'closeTermModal',
    value: function closeTermModal() {
      this.setState({ isOpenTermModal: false });
    }
  }, {
    key: 'render',
    value: function render() {
      // const banner1920 = require('./banner-1920.jpg');
      // const bannerDesktop = require('./banner-desktop.jpg');
      // const bannerMobile = require('./banner-mobile.jpg');

      // const banner1920My = require('./banner-1920-my.jpg');
      // const bannerDesktopMy = require('./banner-desktop-my.jpg');
      // const bannerMobileMy = require('./banner-mobile-my.jpg');
      var bannerMobile = require('./banner-mobile.jpg');
      var bannerDesktopText = require('./banner-desktop-text.png');
      var digiImage = require('./digi.png');
      var tmtImage = require('./tmt.png');
      // const bannerMobile2 = require('./banner-mobile2.jpg');
      // const simImage = require('./tourist-sim.png');
      // const hr = require('./hr.png');
      // const {items} = this.props;
      // const {isLoggedIn, phone} = this.props;
      // const {trips, reviews, inspirations, locale, messages} = this.props;
      var _props = this.props,
          trips = _props.trips,
          reviews = _props.reviews,
          inspirations = _props.inspirations;

      return _react3.default.createElement(
        'div',
        { styleName: 'main-container' },
        _react3.default.createElement(_reactHelmet2.default, {
          meta: [{ 'property': 'og:image', 'content': 'https://www.takemetour.com' + bannerMobile }]
        }),
        _react3.default.createElement(
          'div',
          { styleName: 'banner-wrapper' },
          _react3.default.createElement(
            'div',
            { styleName: 'banner-desktop' },
            _react3.default.createElement(
              'div',
              { styleName: 'banner-desktop-inner' },
              _react3.default.createElement(
                'div',
                { styleName: 'banner-desktop-box' },
                _react3.default.createElement(
                  'div',
                  { styleName: 'banner-desktop-text-container' },
                  _react3.default.createElement('img', { src: bannerDesktopText, alt: 'banner' })
                ),
                _react3.default.createElement(
                  'h3',
                  { styleName: 'banner-normal-header' },
                  _react3.default.createElement(
                    'span',
                    null,
                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.description' })
                  )
                ),
                _react3.default.createElement(
                  'div',
                  { styleName: 'action-container' },
                  _react3.default.createElement(
                    'a',
                    { styleName: 'btn-digi-container', onClick: this.openSignup },
                    _react3.default.createElement(
                      'div',
                      { styleName: 'btn-digi' },
                      'DG40'
                    )
                  ),
                  _react3.default.createElement(
                    'p',
                    null,
                    _react3.default.createElement(
                      'a',
                      { styleName: 'term-link', onClick: this.openTermModal },
                      _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.terms_n_conditions' })
                    )
                  )
                )
              ),
              _react3.default.createElement(
                'div',
                { styleName: 'tmt-logo-container' },
                _react3.default.createElement('img', { src: tmtImage, alt: 'TakeMeTour logo' })
              ),
              _react3.default.createElement(
                'div',
                { styleName: 'dtac-logo-container' },
                _react3.default.createElement('img', { src: digiImage, alt: 'Digi logo' })
              )
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'banner-mobile' },
            _react3.default.createElement('img', { src: bannerMobile, alt: 'banner' }),
            _react3.default.createElement(
              'div',
              { styleName: 'banner-mobile-content' },
              _react3.default.createElement(
                'h3',
                { styleName: 'banner-normal-header' },
                _react3.default.createElement(
                  'span',
                  null,
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.description' })
                )
              ),
              _react3.default.createElement(
                'div',
                { styleName: 'action-container' },
                _react3.default.createElement(
                  'a',
                  { styleName: 'btn-digi-container', onClick: this.openSignup },
                  _react3.default.createElement(
                    'div',
                    { styleName: 'btn-digi' },
                    'DG40'
                  )
                ),
                _react3.default.createElement(
                  'p',
                  null,
                  _react3.default.createElement(
                    'a',
                    { styleName: 'term-link', onClick: this.openTermModal },
                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.terms_n_conditions' })
                  )
                )
              )
            )
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'inner-10' },
          _react3.default.createElement(
            'div',
            { styleName: 'main-section' },
            _react3.default.createElement(_Breadcrumbs2.default, { type: 'Digi', customStyle: { paddingTop: '10px' } }),
            _react3.default.createElement(
              'h2',
              { styleName: 'header' },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.recommended_trips' })
            ),
            trips.map(function (trip, index) {
              return _react3.default.createElement(_Trip2.default, { trip: trip, key: 'digi-' + index, index: index });
            }),
            _react3.default.createElement(
              'p',
              { styleName: 'text-trip' },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.interest' })
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'btn-container' },
              _react3.default.createElement(
                _Link2.default,
                { to: '/to/Bangkok', styleName: 'btn-find-out' },
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.interest.button' })
              )
            )
          )
        ),
        _react3.default.createElement(_AboutLocalExperts2.default, { bgColor: 'gray' }),
        _react3.default.createElement(_SeeInspiration2.default, { inspirationLayouts: inspirations, showAllInspirations: false }),
        _react3.default.createElement(_FeaturedReviews2.default, { reviews: reviews }),
        _react3.default.createElement(_AsSeenOn2.default, null),
        _react3.default.createElement(
          _Modal2.default,
          { isOpen: this.state.isOpenTermModal, id: 'digi-term', onClose: this.closeTermModal, style: { padding: '0' }, centerVertical: true },
          _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(
              'div',
              { styleName: 'modal-header' },
              _react3.default.createElement(
                'h3',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.terms_n_conditions' })
              )
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'modal-content' },
              _react3.default.createElement(
                'p',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.terms_n_conditions.description' }),
                _react3.default.createElement('br', null),
                _react3.default.createElement(
                  'span',
                  null,
                  '     '.replace(/ /g, '\xA0'),
                  '1. ',
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.terms_n_conditions.bullet_1' })
                ),
                _react3.default.createElement('br', null),
                _react3.default.createElement(
                  'span',
                  null,
                  '     '.replace(/ /g, '\xA0'),
                  '2. ',
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.terms_n_conditions.bullet_2' })
                ),
                _react3.default.createElement('br', null),
                _react3.default.createElement(
                  'span',
                  null,
                  '     '.replace(/ /g, '\xA0'),
                  '3. ',
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.terms_n_conditions.bullet_3' })
                ),
                _react3.default.createElement('br', null),
                _react3.default.createElement(
                  'span',
                  null,
                  '     '.replace(/ /g, '\xA0'),
                  '4. ',
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.terms_n_conditions.bullet_4' })
                ),
                _react3.default.createElement('br', null),
                _react3.default.createElement(
                  'span',
                  null,
                  '     '.replace(/ /g, '\xA0'),
                  '5. ',
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.terms_n_conditions.bullet_5' })
                ),
                _react3.default.createElement('br', null),
                _react3.default.createElement(
                  'span',
                  null,
                  '     '.replace(/ /g, '\xA0'),
                  '6. ',
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.terms_n_conditions.bullet_6' })
                ),
                _react3.default.createElement('br', null)
              )
            )
          )
        )
      );
    }
  }]);
  return Digi;
}(_react2.Component), _class2.propTypes = {
  trips: _react2.PropTypes.array,
  inspirations: _react2.PropTypes.array,
  reviews: _react2.PropTypes.array,
  localExperts: _react2.PropTypes.array,
  openSignup: _react2.PropTypes.func,
  setSessionData: _react2.PropTypes.func,
  loadSessionData: _react2.PropTypes.func,
  setOldPromo: _react2.PropTypes.func,
  locale: _react2.PropTypes.string
}, _temp)) || _class) || _class) || _class));

exports.default = Digi;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Digi/Digi.js
// module id = 1669
// module chunks = 13